class VtPromoScrollPopup extends HTMLElement {
  connectedCallback() {
    if (this.dataset.disabled === 'true') return;
    if (document.body.classList.contains('vt-ppc-funnel')) return;

    this.threshold = parseFloat(this.getAttribute('data-scroll-threshold') || '0.1');
    this.storageKey = this.getAttribute('data-storage-key') || 'vt_promo_popup';
    this.dialog = this.querySelector('.vt-promo-popup__dialog');
    this.closeBtns = this.querySelectorAll('[data-promo-close]');
    this.motionMs = 380;
    this.inertTargets = [];

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.motionMs = 0;
    }

    if (sessionStorage.getItem(this.storageKey) === '1') return;

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll();

    this.closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => this.dismiss());
    });

    this.onKeydown = (e) => {
      if (e.key === 'Escape' && !this.hidden && this.dataset.open === 'true') this.dismiss();
    };
    document.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.removeEventListener('keydown', this.onKeydown);
  }

  onScroll() {
    if (this.shown) return;
    const doc = document.documentElement;
    const max = Math.max(doc.scrollHeight - window.innerHeight, 1);
    if (window.scrollY / max >= this.threshold) {
      this.open();
    }
  }

  lockPageInteraction() {
    const selectors = ['#MainContent', '.section-header', 'footer', '.vt-quiz-pill', '.vt-app-bar'];
    this.inertTargets = selectors
      .map((sel) => document.querySelector(sel))
      .filter(Boolean);

    this.inertTargets.forEach((el) => {
      el.setAttribute('inert', '');
      el.setAttribute('aria-hidden', 'true');
    });
  }

  unlockPageInteraction() {
    this.inertTargets.forEach((el) => {
      el.removeAttribute('inert');
      el.removeAttribute('aria-hidden');
    });
    this.inertTargets = [];
  }

  open() {
    this.shown = true;
    this.hidden = false;
    this.removeAttribute('data-closing');
    this.setAttribute('data-open', 'true');
    document.documentElement.classList.add('vt-promo-popup-open');
    document.body.classList.add('vt-promo-popup-open');
    this.lockPageInteraction();

    window.removeEventListener('scroll', this.onScroll);
    const close = this.querySelector('.vt-promo-popup__close');
    close?.focus({ preventScroll: true });
  }

  dismiss() {
    if (this.hidden || this.dataset.closing === 'true') return;

    this.dataset.closing = 'true';
    this.removeAttribute('data-open');

    const finish = () => {
      this.hidden = true;
      delete this.dataset.closing;
      document.documentElement.classList.remove('vt-promo-popup-open');
      document.body.classList.remove('vt-promo-popup-open');
      this.unlockPageInteraction();
      try {
        sessionStorage.setItem(this.storageKey, '1');
      } catch (e) {}
    };

    if (this.motionMs === 0) {
      finish();
      return;
    }

    window.setTimeout(finish, this.motionMs);
  }
}

if (!customElements.get('vt-promo-scroll-popup')) {
  customElements.define('vt-promo-scroll-popup', VtPromoScrollPopup);
}
